import dayjs from 'dayjs';

import { Signature } from '@/models/report';

export interface FooterSignature {
  signerName: string;
  signedAt: string;
}

/** Footer signature block derived from a report's signature, or undefined when unsigned. */
export function buildFooterSignature(
  signature: Signature | null | undefined
): FooterSignature | undefined {
  if (!signature) return undefined;
  return {
    signerName: `${signature.signerFirstName ?? ''} ${signature.signerLastName ?? ''}`,
    signedAt: dayjs(signature.createdAt).format('MMM D, YYYY, h:mm A'),
  };
}
